import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { F_STR } from 'assets/FormatNumbers'
import { promiseVoidF } from 'types/FunctionTypes'
import { messageColor } from 'types/ReferTypes'
import { response } from 'utils/apiUtil'

type PageState = {
  openAlert: boolean // アラートを表示しているか
  submitFunction: (file?: File) => Promise<void> // アラートで決定ボタン押下後に動く関数
  loading: boolean // ローディング状態
  messageAlert: string // アラートダイアログのメッセージ
  isNotDeleteMessage: boolean // メッセージ削除しないフラグ
  expand: boolean // 検索部分を開いているか
  message: string // メッセージ
  messageColor: messageColor // メッセージの色
  error: boolean // ダイアログを開く際にエラーが発生しているか
}
const initialState: PageState = {
  openAlert: false, // アラートを表示しているか
  submitFunction: async () => {}, // アラートで決定ボタン押下後に動く関数
  loading: false, // ローディング状態
  messageAlert: F_STR, // アラートダイアログのメッセージ
  isNotDeleteMessage: false, // メッセージ削除しないフラグ
  expand: true, // 検索部分を開いているか
  message: F_STR, // メッセージ
  messageColor: 'red', // メッセージの色
  error: false, // ダイアログを開く際にエラーが発生しているか
}
export const PageSlice = createSlice({
  name: 'Page',
  initialState: initialState,
  reducers: {
    // アラートを開く //===========================//
    openAlert: (state, action: PayloadAction<{ message: string; func: promiseVoidF; err: boolean }>) => {
      state.openAlert = true
      state.messageAlert = action.payload.message
      state.submitFunction = action.payload.func
      state.error = action.payload.err
    },
    // アラートを閉じる //===========================//
    closeAlert: (state) => {
      state.openAlert = false
      state.loading = false
    },
    // メッセージ変更(青字) //===========================//
    changeMessageSuccess: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'blue'
    },
    // メッセージ変更(赤字) //===========================//
    changeMessageError: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'red'
    },
    // メッセージ変更(直接設定) //===========================//
    changeMessageDirect: (state, action: PayloadAction<{ message: string; color: messageColor }>) => {
      state.message = action.payload.message
      state.messageColor = action.payload.color
    },
    // メッセージ変更(APIレスポンスから設定) //===========================//
    changeMessage: (state, action: PayloadAction<response<any>>) => {
      const payload = action.payload
      state.message = payload.message
      state.messageColor = payload.error || payload.alert ? 'red' : 'blue'
    },
    // メッセージ初期化 //===========================//
    deleteMessage: (state) => {
      state.message = initialState.message
    },
    // アラートダイアログメッセージ変更 //===========================//
    changeMessageAlert: (state, action: PayloadAction<string>) => {
      state.messageAlert = action.payload
    },
    // メッセージ削除しないフラグを変更 //===========================//
    changeIsNotDeleteMessage: (state, action: PayloadAction<boolean>) => {
      state.isNotDeleteMessage = action.payload
    },
    // 検索部分開閉 //===========================//
    changeExpand: (state) => {
      state.expand = !state.expand
    },
    // ローディング開始 //===========================//
    startLoading: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.messageColor = 'green'
      state.message = action.payload
    },
    // ローディング終了 //===========================//
    endLoading: (state) => {
      state.loading = false
    },
    // ローディング状態変更 //===========================//
    changeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    //ページ情報 初期化 //===========================//
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof PageState = key as keyof PageState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  openAlert, // アラートを開く
  closeAlert, // アラートを閉じる
  changeMessageSuccess, // メッセージ変更(青字)
  changeMessageError, // メッセージ変更(赤字)
  changeMessageDirect, // メッセージ変更(直接設定)
  changeMessage, // メッセージ変更(APIレスポンスから設定)
  deleteMessage, // メッセージ初期化
  changeMessageAlert, // アラートダイアログメッセージ変更
  changeIsNotDeleteMessage, // メッセージ削除しないフラグを変更
  changeExpand, // 検索部分開閉
  startLoading, // ローディング開始
  endLoading, // ローディング終了
  changeLoading, // ローディング状態変更
  format, // ページ情報 初期化
} = PageSlice.actions
export default PageSlice.reducer
